import moment from "moment";
import momentZone from "moment-timezone";

const HAS_TIMEZONE = /(?:Z|[+-]\d{2}:?\d{2})$/i;
const LEGACY_FORMATS = [moment.ISO_8601, "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD, HH:mm", "YYYY-MM-DD HH:mm"];

export const formatLocalTime = (time, targetTimeZone = momentZone.tz.guess()) => {
  if (!time) return "Not available";

  const value = String(time).trim();
  const isUnixSeconds = /^\d{10}$/.test(value);
  const isUnixMilliseconds = /^\d{13}$/.test(value);
  const sourceTime = isUnixSeconds
    ? moment.unix(Number(value))
    : isUnixMilliseconds
      ? moment(Number(value))
      : HAS_TIMEZONE.test(value)
        ? moment.parseZone(value)
        : moment.tz(value, LEGACY_FORMATS, true, "Australia/Sydney");

  if (!sourceTime.isValid()) return "Not available";

  return sourceTime.tz(targetTimeZone).format("D MMM YYYY, h:mm A z");
};

export const getLocalTimeZone = () => momentZone.tz.guess().replace(/_/g, " ");

const useTimeFormat = () => {
  const formateLocalTime = (time) => formatLocalTime(time);

  return { formateLocalTime };
};

export default useTimeFormat;
